import React from "react";
import { useHistory } from "react-router-dom";

import { URLS } from "../../../../../../utils";

import { Modal, FloatingContainer } from "../../../../../Components/Wrappers";
import { FloatingContent } from "../../../../../../components/molecules/floatingContent";
import { ClearConfirmationModal } from "../../../Components/ClearConfirmationModal";
import {
  CampaignCreatorCardModal,
  CreatorCardNewModal,
  CreatorCardOGModal,
  CreatorCardTierModal,
  CreatorCardTopModal,
} from "../../../../../Components/Modals";
import { Remix1080 } from "../../../../../Components/Modals/Remix1080pCallout";
import { CustomizeProfile } from "../../../../Account/Components/ConnectedAccounts";

export default function StudioModals({
  modal,
  getFreshProfile,
  allstarUser,
  handleCardToggle,
  toggleModal,
}: any) {
  const history = useHistory();

  return (
    <>
      <Modal
        isModalOpen={modal.type === "username"}
        setModalOpen={toggleModal}
        handleModalClose={() => {
          history.push(`/${URLS.ACCOUNT_SETTINGS}`);
        }}
        disableOutsideClose={undefined}
        name="studio-username-modal"
      >
        <FloatingContainer>
          <FloatingContent
            title={<>Set up your profile</>}
            sub={<>A username is required to use Creator Cards</>}
            body={
              <CustomizeProfile
                isPopup={true}
                setModalOpen={toggleModal}
                getFreshProfile={getFreshProfile}
                allstarUser={allstarUser}
              ></CustomizeProfile>
            }
          />
        </FloatingContainer>
      </Modal>
      <CreatorCardTopModal
        isOpen={modal.type === "top"}
        setIsOpen={toggleModal}
        handleModalClose={() => {}}
        disableOutsideClose={false}
      />{" "}
      <CreatorCardNewModal
        isOpen={modal.type === "new"}
        setIsOpen={toggleModal}
        handleModalClose={() => {}}
        disableOutsideClose={false}
      />
      <CreatorCardOGModal
        isOpen={modal.type === "exclusive"}
        setIsOpen={toggleModal}
        handleModalClose={() => {}}
        disableOutsideClose={false}
      />{" "}
      <CreatorCardTierModal
        state={{
          isOpen: [500, 400, 300, 200, 100].includes(modal.type),
          tier: modal.type,
          data: modal.data,
        }}
        setState={toggleModal}
        handleModalClose={() => {}}
        disableOutsideClose={false}
        handleCardToggle={handleCardToggle}
      />
      <CampaignCreatorCardModal
        card={modal.card}
        setIsOpen={toggleModal}
        isOpen={modal.type === "campaign"}
        handleModalClose={() => {}}
        disableOutsideClose={false}
        handleCardToggle={handleCardToggle}
      />
      <Modal
        isModalOpen={modal.type === "clear"}
        setModalOpen={toggleModal}
        handleModalClose={undefined}
        disableOutsideClose={undefined}
      >
        <FloatingContainer>
          <ClearConfirmationModal setModalOpen={toggleModal} />
        </FloatingContainer>
      </Modal>
      <Remix1080 />
    </>
  );
}
